import React from 'react'
import Footer from '../Components/global/Footer'
import Header from '../Components/global/Header'
import '../assets/css/not-found.css'
import ComingSoonComponent from '../Components/global/ComingSoonComponent'

const ComingSoon = ({ header = true, footer = true }) => {
  return (
    <div style={{ backgroundColor: 'whitesmoke' }}>
      {header && <Header />}
      <ComingSoonComponent />
      {footer && <Footer />}
    </div>
  )
}

export default ComingSoon
